import { call } from 'typed-redux-saga';
export function createSagaErrorBoundary(onError) {
  const callWithErrorLogging = function (saga) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return function* safeSaga() {
      try {
        yield call(saga, ...args);
      } catch (err) {
        onError(err);
      }
    };
  };

  return callWithErrorLogging;
}